import React from 'react';
import Typical from 'react-typical';
import './Banner.css';
import image from '../../../images/Abdullah-Al-Akash.jpg'
import spinner from '../../../images/spinner.gif';
import linkedIn from '../../../images/linkedIn.png';
import gitHub from '../../../images/github.png';
import facebook from '../../../images/facebook.png';

const BannerContent = () => {
        // Spinner:
        if (!image) {
                return <div className="spinner">
                        <div className="loading d-flex justify-content-center align-items-center mt-5">
                                <img className="img-fluid mt-5" src={spinner} alt="" />
                        </div>
                </div>
        }
        return (
                <div className="banner-content mt-4 pt-5">
                        <div className="row mt-5 pt-5">
                                <div className="col-lg-6 tex-white col-md-6 d-flex align-items-center order-lg-1 order-md-1 order-2">
                                        <div className="banner-headline"
                                                data-aos="fade-up"
                                                data-aos-duration="2000">
                                                <h1 className="text-white fw-bold fs-1 pt-3">Hi, I am <span className="name">Abdullah Al Akash</span></h1>
                                                <div className="react-type">
                                                        <h2 className="tex-light fw-bold" style={{
                                                                'background': 'linear-gradient(to right, rgb(255, 180, 0), rgb(255, 115, 0))',
                                                                '-webkit-background-clip': 'text',
                                                                '-webkit-text-fill-color': 'transparent'
                                                        }}>
                                                                <Typical
                                                                        steps={[
                                                                                'Programmer', 1000,
                                                                                'React Developer', 1000,
                                                                                'Javascript Developer', 1000,
                                                                                'MERN Stack Developer', 1000
                                                                        ]}
                                                                        loop={Infinity}
                                                                        wrapper="p"
                                                                />

                                                        </h2>
                                                </div>
                                                <p className="text-white pt-3 pe-2">I am a self-curious Web Developer as my educational background is not related programming, I am student of mathematics but enjoy Web Development so much, try to develop the front end of a web application using React.js and the back-end using Node.js(express) with comfortable. Besides always ready to learn any new technology. <br /> <br /> Honestly, I am excited to start my career as a web developer as well as to enhance my workplace and reputation day by day. </p>
                                                <div className="social-icon pt-2"
                                                        data-aos="zoom-in"
                                                        data-aos-duration="3000"
                                                >

                                                        <a href="https://www.linkedin.com/in/abdullahalakash/" target="_blank">
                                                                <img className="single-icon" src={linkedIn} alt="" />
                                                        </a>

                                                        <a href="https://github.com/Abdullah-Al-Akash" target="_blank">
                                                                <img className="single-icon" src={gitHub} alt="" />
                                                        </a>

                                                        <a href="https://web.facebook.com/abdullah.akash.al" target="_blank">
                                                                <img className="single-icon" src={facebook} alt="" />
                                                        </a>

                                                </div>
                                                {/* Hire Button */}
                                                <div className="pt-3 d-flex">
                                                        {/* <div className="main-btn">
                                                                <a href="https://www.linkedin.com/in/abdullahalakash/" target="_blank">
                                                                        <span>Hire Me</span>
                                                                </a>
                                                        </div>
                                                        <div className="main-btn ms-md-4 ms-lg-4">
                                                                <a href="https://drive.google.com/uc?id=1o6S6Bub3ab4lYj1RI3jlfzS_0uVlAMtZ&export=download" target="_blank">
                                                                        <span>Resume</span>
                                                                </a>
                                                        </div> */}
                                                        <a className="special-btn" href="https://www.linkedin.com/in/abdullahalakash/" target="_blank">
                                                                <span>Hire Me</span> <i></i>
                                                        </a>
                                                        <a className="ms-2 special-btn" href="https://drive.google.com/uc?id=1o6S6Bub3ab4lYj1RI3jlfzS_0uVlAMtZ&export=download" target="_blank">
                                                                <span>Resume</span> <i></i>
                                                        </a>
                                                </div>
                                        </div>
                                </div>
                                <div className="col-lg-6 col-md-6 mt-5 order-sm-2 order-md-2 order-1 banner-image"
                                        data-aos="zoom-in-up"
                                        data-aos-duration="3000"
                                >
                                        <img className="img-fluid main-img" src={image} alt="" />
                                </div>
                        </div>
                </div>
        );
};

export default BannerContent;